import React from 'react';
import ResetPassword from '../components/auth/ResetPassword';

const ResetPasswordPage = () => {
  return <ResetPassword />;
};

export default ResetPasswordPage;